import Flickity from 'flickity'
import imagesLoaded from 'flickity-imagesloaded'
import getClosest from '../helpers/getClosest'

var trigger = document.querySelector(".open-gallery");
var gallery = document.querySelector(".main-carousel");
var closeGallery = document.querySelector(".close-gallery");

if (gallery && trigger) {
    trigger.addEventListener("click", function () {
        var parent = window.getClosest(this, '.hero');
        parent.querySelector(".previous").classList.add("showPre");
        parent.querySelector(".next").classList.add("showNext");
        parent.classList.add("visually-hidden");
        parent.querySelector(".overlay--hero").classList.add("hide");
        parent.querySelector(".main-carousel").classList.remove("visually-hidden");
        parent.querySelector(".close-gallery").classList.remove("visually-hidden");
        parent.querySelector(".close-gallery").classList.add("closed--gal");

    });

    closeGallery.addEventListener("click", function () {
        var parent = window.getClosest(this, '.hero');
        parent.classList.remove("visually-hidden");
        parent.querySelector(".previous").classList.remove("showPre");
        parent.querySelector(".next").classList.remove("showNext");
        parent.querySelector(".overlay--hero").classList.remove("hide");
        parent.querySelector(".main-carousel").classList.add("visually-hidden");
        parent.querySelector(".close-gallery").classList.add("visually-hidden");
        parent.querySelector(".close-gallery").classList.remove("closed--gal");
    });

    var elem = document.querySelector('.main-carousel');

    var flkty = new Flickity(elem, {
        // options
        cellAlign: 'left',
        freeScroll: true,
        wrapAround: true
    });
}

if (gallery && !trigger) {
    var elem = document.querySelector('.main-carousel');

    var flkty = new Flickity(elem, {
        // options
        cellAlign: 'left',
        freeScroll: true,
        wrapAround: true
    });

    elem.querySelector(".previous").classList.add("showPre");
    elem.querySelector(".next").classList.add("showNext");
}






// WEBPACK FOOTER //
// ./scripts/components/carousel.js